import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  width: 100%;
  margin-bottom: ${(props) => (props.isMarginBottomZero ? '0px' : '16px')};
  ${(props) => props.css}
`;
